<template>
  <div
    class="go-back-main d-flex align-center"
  >
    <div
      style="color: var(--text-color-o-65); cursor: pointer"
      class="d-flex align-center"
      @click="goBack"
    >
      <a-icon type="left" />
      <template v-if="!appInfo.icon">
        <span>返回上一页</span>
      </template>
      <template v-else>
        <div class="go-back-info">
          <div class="go-back-info__icon">
            <BizIcon
              :type="appInfo.icon"
              style="font-size: 40px;"
            />
          </div>
          <div class="go-back-info-right">
            <div class="go-back-info-title">{{ appInfo.title }}</div>
            <div class="go-back-info-des">{{ appInfo.subTitle }}</div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
import BizIcon from '@/components/BizIcon';

export default {
  components: {
    BizIcon,
  },
  data() {
    return {
      appInfo: {},
    };
  },
  computed: {
    ...mapState('user', ['globalState']),
  },
  watch: {
    globalState: {
      handler(val) {
        if (val) {
          const { appCard } = val;
          if (appCard) {
            this.appInfo = appCard;
            // 避免其他非应用(app-center中的应用)的二级页面也加载应用信息，所以清除一下
            this.updateGlobalState({
              appCard: '',
            });
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ...mapMutations('user', ['updateGlobalState']),
    goBack() {
      const { path } = this.$route;
      // 由于装修页面添加了iframe，导致点击返回会无法直接返回到小程序列表页，所以直接跳转过去
      if (path.indexOf('/miniprogram/decoratey') > -1) {
        this.$router.replace({
          path: '/app-center/miniprogram/index',
        });
      } else {
        this.$router.back();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.go-back-main {
  height: 64px;
  background: #fff;
  box-shadow: 0 2px 6px 0px rgba(0, 0, 0, .08);
  padding: 0 20px;
  position: relative;
  z-index: 1;
}
.go-back-info {
  display: flex;
  align-items: center;
  margin-left: 10px;
}
.go-back-info-title {
  color: #333;
  font-size: 16px;
  font-weight: 600;
}
.go-back-info-des {
  font-size: 14px;
  color: #666;
}
.go-back-info__icon {
  border-radius: 15px;
  overflow: hidden;
  margin-right: 14px;
}
</style>
